export default __webpack_public_path__ + "static/media/logo_m.62121542.png";